import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import CustomTabs from "../../../../../../../components/app/CustomTabs";
import { ChartActionStrip } from "../../../../../../../components/app/provider/patient/chart";
import { useRoleController } from "../../../../../../../components/useRoleController";
import { useReduceDisclosure } from "../../../../../../../hooks/use-reduce-disclosure";
import FullScriptIframe from "../../../../../../../services/fullscript/FullScriptIframe";
import { getXtenantId, roleFilter } from "../../../../../../../utils/utils";
import UpsertLabRequisitionForm from "../../../../scheduling/appointment/encounter/default-forms/UpsertLabRequisitionForm";
import UpsertPrescriptionForm from "../../../../scheduling/appointment/encounter/prescription/UpsertPrescriptionForm";
import PatientOrderNew from "./orders/PatientOrderNew";
import OderResultNew from "./result/OderResultNew";
import UpsertResult from "./result/UpsertResultNew";

const PatientOrderNewLayout = () => {
  const isVisitNotePage = window.location.pathname.includes("/visit-note");
  const [orderDisc, labResult, prescriptionDisc, fullScriptDisc] =
    useReduceDisclosure(4);

  const currentActiveTab = location.pathname.split("/").pop();
  const [activeTab, setActiveTab] = useState<string>(
    currentActiveTab === "order" || isVisitNotePage
      ? ""
      : currentActiveTab || ""
  );

  const navigate = useNavigate();
  const [prefillData, setPrefillData] = useState<any>(null);
  const { hasView } = useRoleController("Imaging order");

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <FullScriptIframe
        disclosureHost={fullScriptDisc}
        xTENANTID={getXtenantId() ?? undefined}
      />
      <UpsertLabRequisitionForm disclosureHost={orderDisc} />
      <UpsertResult disclosureHost={labResult} />
      <UpsertPrescriptionForm
        prefillData={prefillData}
        setPrefillData={setPrefillData}
        disclosureHost={prescriptionDisc}
      />

      <ChartActionStrip
        startContent={
          <CustomTabs
            tabsData={roleFilter({
              list: TABS_DATA,
              compWith: { "": hasView },
            })}
            value={activeTab}
            onChange={(v) => {
              setActiveTab(v);
              if (!isVisitNotePage) navigate(v);
            }}
          />
        }
        endContent={
          <>
            {activeTab === "result" && (
              <ChartActionStrip.Button
                startIcon={<AddIcon />}
                onClick={() => labResult.open()}
              >
                Add New Result
              </ChartActionStrip.Button>
            )}
            {/* note: hiding this as discussed with team in meeting [AUG:13]
             {activeTab === "" && (
              <ChartActionStrip.Button
                startIcon={<AddIcon />}
                variant="outlined"
                onClick={() => fullScriptDisc.open()}
              >
                Add Lab from Fullscript
              </ChartActionStrip.Button>
            )} */}
            {activeTab === "" && (
              <ChartActionStrip.Button
                startIcon={<AddIcon />}
                onClick={() => orderDisc.open()}
              >
                Add New Order
              </ChartActionStrip.Button>
            )}
          </>
        }
      />

      <Box sx={{ flex: 1, overflow: "hidden" }}>
        {isVisitNotePage ? activeSubTab[activeTab] : <Outlet />}
      </Box>
    </Box>
  );
};
export default PatientOrderNewLayout;

const activeSubTab: Record<string, React.ReactNode> = {
  "": <PatientOrderNew />,
  result: <OderResultNew />,
};

const TABS_DATA = [
  {
    value: "",
    label: "Order",
  },
  {
    value: "result",
    label: "Result",
  },
];
